import React, { useEffect } from 'react'
import GenerateReport from "../check_in/GenerateReport"

export default function ReportsPage() {

    return <GenerateReport />
}